import { Link } from "react-router-dom";
import Footer from "@/components/Footer";

export default function AuthShell({ title, eyebrow, subtitle, children, side = "right" }) {
  return (
    <div className="min-h-screen bg-[#FFFBF5] flex flex-col" data-testid="auth-shell">
      <header className="px-6 sm:px-10 lg:px-16 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 select-none" data-testid="auth-home-link" aria-label="Helencia">
          <img src="/helencia-logo-256.png" alt="" width={36} height={36} className="rounded-xl shadow-[0_3px_10px_-2px_rgba(110,75,42,0.18)]" style={{ width: 36, height: 36 }} />
          <span className="font-serif text-2xl text-[#1A1A1A]">Helencia</span>
        </Link>
        <Link to="/" className="text-xs caption-label text-[#A26F3E] hover:text-[#1A1A1A] transition" data-testid="auth-back-home">
          ← Retour à l'accueil
        </Link>
      </header>

      <main className="flex-1 grid lg:grid-cols-2">
        {/* Visual side */}
        <div className={`hidden lg:flex items-center justify-center bg-[#FAF3EA] relative overflow-hidden ${side === "left" ? "order-1" : "order-2"}`}>
          <img
            src="https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1600&q=80"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
            style={{ filter: "saturate(0.9) contrast(1.05)" }}
          />
          <div className="absolute inset-0" style={{
            background: "linear-gradient(180deg, rgba(40,22,10,0.25) 0%, rgba(40,22,10,0.55) 60%, rgba(20,12,6,0.85) 100%)",
          }} />
          <div className="relative px-12 pb-16 self-end text-white max-w-md">
            <p className="caption-label text-[#E6C29A]">Helencia</p>
            <h2 className="font-serif text-4xl mt-3 leading-tight">
              Une plateforme <span className="italic text-[#D4A574]">pour les talents</span> de la mode.
            </h2>
          </div>
        </div>

        {/* Form side */}
        <div className={`flex items-center justify-center px-6 sm:px-10 lg:px-20 py-12 ${side === "left" ? "order-2" : "order-1"}`}>
          <div className="w-full max-w-md">
            {eyebrow && <p className="caption-label text-[#A26F3E]">{eyebrow}</p>}
            <h1 className="font-serif text-4xl sm:text-5xl text-[#1A1A1A] mt-2 leading-[1.05]">{title}</h1>
            {subtitle && <p className="text-[#6E4B2A] mt-3 text-sm leading-relaxed">{subtitle}</p>}
            <div className="mt-8">{children}</div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
